import React from "react";
import dreamExLogo from "../../icons/dx_connect_logo.svg";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

const Sidebar = ({ navItems = [] }) => {
  return (
    <Wrapper>
      <div style={{ textAlign: "center", marginBottom: "50px" }}>
        <img height={40} src={dreamExLogo} alt="Dream Exchange" />
      </div>

      {navItems.map((item) => (
        <NavItem
          key={`link_${item.title}`}
          to={item.link}
          exact={item.exact}
          activeStyle={{
            background: "rgba(0,0,0,0.3)",
            color: "#fff",
            fontWeight: 600,
          }}
        >
          <img
            width="20px"
            src={item.icon}
            alt={item.title}
            style={{ marginRight: 10 }}
          />
          {item.title}
        </NavItem>
      ))}
      <Copyright>&copy; 2020 Dream Exchange LLC</Copyright>
    </Wrapper>
  );
};

const Copyright = styled.div`
  position: absolute;
  left: 0px;
  width: 100%;
  text-align: center;
  bottom: 5px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 10px;
`;

const Wrapper = styled.div`
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  width: 190px;
  padding: 20px 10px;
  background: linear-gradient(to bottom, #0c0a40 0%, #2b68b2 50%, #23b6ea 100%);
`;

const NavItem = styled(NavLink)`
  display: block;
  height: 40px;
  line-height: 40px;
  color: #efefef;
  border-radius: 6px;
  font-size: 12px;
  padding: 0px 10px;
  cursor: pointer;
  margin-bottom: 5px;
  font-weight: 400;
  transition: 0.3s ease all;
  position: relative;

  :hover {
    color: #fff;
    text-decoration: none;
  }
`;

export default Sidebar;
